import { render, staticRenderFns } from "./codFodList.vue?vue&type=template&id=21998158&scoped=true&"
import script from "./codFodList.vue?vue&type=script&lang=js&"
export * from "./codFodList.vue?vue&type=script&lang=js&"
import style0 from "./codFodList.vue?vue&type=style&index=0&id=21998158&scoped=true&lang=css&"
import style1 from "./codFodList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21998158",
  null
  
)

export default component.exports